var render = function render(){var _vm=this,_c=_vm._self._c;return _c('actions',{staticClass:"language-dropdown",attrs:{"actions":_vm.languages,"selected":_vm.selected,"mode":"selectlist"},on:{"change":_vm.changeLanguage}})
}
var staticRenderFns = []

export { render, staticRenderFns }